import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import skillookAdmin from "apis/skillookAdmin";

// First, create the thunk
export const loginRequest = createAsyncThunk("login", async (args) => {
	const [data, callback] = args;
	const response = await skillookAdmin.post("admin/auth/signIn", data);
	localStorage.setItem("token", response.data.data.accessToken);
	localStorage.setItem("refreshToken", response.data.data.refreshToken);
	callback();
	return response.data.token;
});

// Then, handle actions in your reducers:
const loginSlice = createSlice({
	name: "auth",
	initialState: { token: "", message: "", loading: false, language: localStorage.getItem("language") || "de" },
	reducers: {
		// standard reducer logic, with auto-generated action types per reducer
		logOut(state, action) {
			localStorage.removeItem("token");
			window.location.reload();
			return [];
		},
		changeLanguage(state, action) {
			localStorage.setItem("language", action.payload);
			return { ...state, language: action.payload };
		},
	},
	extraReducers: {
		// Add reducers for additional action types here, and handle loading state as needed
		[loginRequest.fulfilled]: (state, action) => {
			// Add key to the state array
			return { ...state, token: action.payload, message: "", loading: false };
		},
		[loginRequest.pending]: (state) => {
			return { ...state, loading: true };
		},
		[loginRequest.rejected]: (state, action) => {
			return {
				...state,
				token: action.payload,
				message: "Incorrect Email or Password",
				loading: false,
			};
		},
	},
});

export const { logOut, changeLanguage } = loginSlice.actions;

export default loginSlice.reducer;
